import { h } from "../../core/dom.js";
import { copy } from "../../config/copy.js";

export const ACRONYM = Object.freeze([
  { letter: "P", word: "Pet", gloss: "il tuo cane" },
  { letter: "A", word: "Affect", gloss: "come si sente" },
  { letter: "W", word: "Watch", gloss: "lo osserva" },
  { letter: "S", word: "System", gloss: "e te lo racconta" }
]);

export function brandBadge() {
  const rows = ACRONYM.map(({ letter, word, gloss }) =>
    h("li", {},
      h("strong", { class: "acronym-letter" }, letter),
      h("span", { class: "acronym-word" }, word),
      h("span", { class: "acronym-gloss muted" }, gloss)));
  const panel = h("div", { class: "acronym hidden", role: "tooltip", id: "acronym" },
    h("p", { class: "acronym-title" }, "Pet Affect Watch System"),
    h("ul", {}, rows));
  const button = h("button", {
    class: "brand",
    type: "button",
    "aria-expanded": "false",
    "aria-describedby": "acronym"
  }, h("span", { class: "brand-mark" }, "🐾"), h("span", {}, copy.appName));

  const setOpen = (open) => {
    panel.classList.toggle("hidden", !open);
    button.setAttribute("aria-expanded", String(open));
  };
  button.addEventListener("click", (event) => {
    event.stopPropagation();
    setOpen(panel.classList.contains("hidden"));
  });
  document.addEventListener("click", (event) => {
    if (!panel.contains(event.target) && event.target !== button) setOpen(false);
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") setOpen(false);
  });
  return { button, panel, wrapper: h("div", { class: "brand-wrap" }, button, panel) };
}
